<template>
  <SalesPanel v-if="running">
    <template #header>
      <h3 class="text-lg leading-6 font-medium text-gray-900">
        Du bist im Probemonat vom Studio Pro mit allen interaktiven Funktionen
      </h3>
    </template>
    <template #default>
      <div class="divide-y divide-gray-200">
        <div class="block hover:bg-gray-50">
          <div class="min-w-0 flex-1 flex items-center">
            <div class="flex items-center px-4 py-4 sm:px-6">
              <div class="flex flex-col">
                <div class="block text-sm font-bold text-gray-600 mb-4">
                  Dein Zugang zum Studio Pro endet automatisch in {{ left }} Tagen
                </div>
                <div class="block mb-4">
                  <Progress :value="passed" :max="total" color="bg-green-300" />
                </div>
                <p class="block text-sm font-medium text-gray-600 mb-4">
                  Während du dauerhaften Zugriff auf die aktuelle Methoden-Sammlung behälst, gibt es unsere Wachstums-Anleitung nur im Abo. Dazu zählen: Experimente, Benachrichtigungen und der Kompass-Assistent mit seinen Empfehlungen.
                </p>
                <SalesButton @click="click">
                  Ich möchte weiter mit Anleitung wachsen
                </SalesButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </SalesPanel>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';

const props = defineProps({podcast: Object});
const router = useRouter();

const trial = computed(() => props.podcast.trial);
const running = computed(() => props.podcast.only_trial);

const total = computed(() => trial.value.trial_days);
const passed = computed(() => trial.value.days_passed);
const left = computed(() => trial.value.days_left);

const click = () =>
{
  const name = {name: 'podcasts.conversion'};
  const params = {params: {id: props.podcast.id}};
  router.push({...name, ...params});
};
</script>

